export class Katalog {
  constructor(
    public id: string,
    public rolle: string,
    public preisgruppe: number,
    public bezeichnung: string,
    public kenntnisse: SkillWithRating[],
    public aufgaben: SkillWithRating[],
    public rollenbezeichnung: string,
    public rvseVersion: number
  ) {
  }
}

export class SkillWithRating {
  constructor(
    public bezeichnung: string,
    public bewertung: number,
    public uuid?: string
  ) {
  }
}
